export default __webpack_public_path__ + "static/media/ArrowAngLeft.6a53166f.svg";